import React from 'react';
import PropTypes from 'prop-types';
import './related-categories.scss';

export function Pill({ text, link, onClick }) {
  if (text && link) {
    return (
      <div className="related-categories__pill">
        <a className="bttn--inline" href={link} onClick={onClick}>
          <span className="related-categories__pill-text">{text}</span>
        </a>
      </div>
    );
  }
  return null;
}

Pill.defaultProps = {
  text: '',
  link: '',
  onClick: () => null
};

Pill.propTypes = {
  link: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func
};